/** 第三方接入接口（与 apps/server/src/routes/integrations.ts 一一对应） */
import type { IntegrationMode, ThirdpartyProvider } from '@znjj/shared';
import { apiGet, apiJson } from './client';

export interface IntegrationAccount {
  id: string;
  provider: ThirdpartyProvider;
  label: string;
  /** live = 走云平台真实链路；mock = 本地模拟数据 */
  mode: IntegrationMode;
  status: string;
  lastSyncAt: string | null;
  nextRefreshAt: string | null;
  createdAt: string;
  /** 已同步进来的设备台数（落 devices 表且默认未认领） */
  deviceCount: number;
}

export interface PlatformProviders {
  tuya: { mode: IntegrationMode; configured: boolean; apiBase: string };
  mihome: { mode: IntegrationMode };
}

export interface IntegrationsData {
  list: IntegrationAccount[];
  platform: PlatformProviders;
}

export interface IntegrationCredentials {
  accessId?: string;
  accessSecret?: string;
  token?: string;
}

export const integrationsApi = {
  list: (): Promise<IntegrationsData> => apiGet<IntegrationsData>('/api/integrations'),

  create: (input: {
    provider: ThirdpartyProvider;
    label?: string;
    credentials?: IntegrationCredentials;
  }): Promise<{ account: IntegrationAccount }> =>
    apiJson<{ account: IntegrationAccount }>('POST', '/api/integrations', input),

  sync: (id: string): Promise<{ account: IntegrationAccount }> =>
    apiJson<{ account: IntegrationAccount }>('POST', `/api/integrations/${id}/sync`),

  update: (
    id: string,
    patch: { label?: string; credentials?: IntegrationCredentials },
  ): Promise<{ account: IntegrationAccount }> =>
    apiJson<{ account: IntegrationAccount }>('PATCH', `/api/integrations/${id}`, patch),

  remove: (id: string): Promise<{ deleted: boolean }> =>
    apiJson<{ deleted: boolean }>('DELETE', `/api/integrations/${id}`),
};

export const integrationKeys = {
  list: ['integrations'] as const,
};
